<!-- eslint-disable max-len -->
<template>
  <div
    :id="id"
    class="properties-field">
    <div class="wrap-properties">
      <!-- Configuration Title -->
      <div class="properties-field-title">
        <h4 class="title">Configuration</h4>
        <div
          class="close-properties"
          @click="!showModalFieldLibrary ? submitForm(true) : null"
        >
          &times;
        </div>
      </div>

      <!-- Configuration Content -->
      <div class="properties-field-content properties-field-content-config">
        <!-- Title Section -->
        <div class="section-field input-field">
          <b-form
            :class="{'error-input' : $v.dataSetup.title.$error}"
            class="input-field m__b--14">
            <label> Title </label>
            <j-input
              v-model="dataSetup.title"
              :error-required="false"
              placeholder="Enter title view"
            />
          </b-form>
        </div>

        <!-- Data Source Section -->
        <div class="section-field input-field">
          <h4 class="title-section">Data Source</h4>

          <!-- Filter Configuration -->
          <div class="configuration-section">
            <div class="configuration-toggle-in-title">
              <div class="wrap-title">
                <h4 class="configuration-section-title">Filter</h4>
                <p class="configuration-section-desc">
                  Filter data according to the parameters
                </p>
              </div>

              <!-- Filter Operator -->
              <div class="filter-option">
                <div class="filter-selected">{{ dataSetup.filterOperator }}</div>
                <i
                  class="fa fa-chevron-down"
                  @click="showFilterOptions = true"
                />

                <!-- Select Filter Operator -->
                <div
                  v-if="showFilterOptions"
                  class="filter-options"
                >
                  <p>Operator</p>

                  <div class="d-flex align-items-center justify-content-around">
                    <div
                      v-for="operator in filterOperatorOptions"
                      :key="operator.id"
                      :class="{'operator-selected': operator.id === dataSetup.filterOperator }"
                      class="operator-option"
                      @click="closeFilterOptions(operator.id)"
                    >
                      {{ operator.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Filter by Value -->
            <h3 class="configuration-section-subtitle">By Value</h3>
            <div
              v-for="(data, index) in dataSetup.filter"
              :key="index"
              class="div-filter"
            >
              <div class="header-filter">
                <div class="index">{{ index + 1 }}</div>
                <i
                  class="fa fa-trash"
                  @click="deleteFilter(index)"
                />
              </div>
              <b-form class="mb-2">
                <label> Column </label>
                <j-single-select
                  v-model="data.key"
                  :error-required="false"
                  :options="variableOptions"
                  :placeholder="'Select Column'"
                  value-format="object"
                  label="label"/>
              </b-form>
              <b-form>
                <label> Value </label>
                <j-input
                  v-model="data.value"
                  :error-required="false"
                  :placeholder="'Input Filter Value'"/>
              </b-form>
            </div>

            <div
              class="btn-add-config"
              @click="addFilter">
              + Add Parameter
            </div>

            <div class="separator" />

            <!-- Filter by Function -->
            <h3 class="configuration-section-subtitle">By Function</h3>
            <div
              v-for="(data, index) in dataSetup.filter_function"
              :key="index"
              class="div-filter"
            >
              <div class="header-filter">
                <div class="index">{{ index + 1 }}</div>
                <i
                  class="fa fa-trash"
                  @click="deleteFilterFunction(index)"
                />
              </div>
              <b-form class="mb-2">
                <label> Column </label>
                <j-single-select
                  v-model="data.key"
                  :error-required="false"
                  :options="variableOptions"
                  :placeholder="'Select Column'"
                  value-format="object"
                  label="label"/>
              </b-form>
              <b-form>
                <label> Function </label>
                <j-single-select
                  v-model="data.value"
                  :options="listFunction"
                  :placeholder="'Select Function'"
                  :error-required="false"
                  label="name" />
              </b-form>
              <div class="separator" />
              <div class="configuration-toggle-in-title">
                <div class="wrap-title">
                  <h4 class="configuration-section-title">Skip Null Value</h4>
                  <p class="configuration-section-desc">
                    If the value of a column filter is null, then the filter will be skipped.
                  </p>
                </div>
                <j-switch
                  v-model="data.skip_null_value"
                  :disabled="isDataset"
                />
              </div>
            </div>

            <div
              class="btn-add-config"
              @click="addFilterFunction">
              + Add Parameter
            </div>
          </div>

          <!-- Sorting Configuration -->
          <div
            v-if="!isDataset"
            class="configuration-section"
          >
            <h4 class="configuration-section-title">Sorting</h4>
            <p class="configuration-section-desc">
              The displayed data can be sorted according to the specified parameters
            </p>
            <b-form
              :class="{'error-input' : $v.dataSetup.sorting.key.$error}"
              class="mb-2"
            >
              <label> Column </label>
              <j-single-select
                v-model="dataSetup.sorting.key"
                :options="variableOptions"
                :placeholder="'Select Column'"
                :error-required="false"
                value-format="object"
                label="label" />
            </b-form>
            <b-form :class="{'error-input' : $v.dataSetup.sorting.order.$error}">
              <label> Order Type </label>
              <j-single-select
                v-model="dataSetup.sorting.order"
                :options="orderOptions"
                :error-required="false"
                :placeholder="'Select Order Type'"
                value-format="object"
                label="label" />
            </b-form>
          </div>

          <!-- Server Side Pagination Configuration -->
          <div class="configuration-section">
            <div class="configuration-toggle-in-title">
              <div class="wrap-title">
                <h4 class="configuration-section-title">Server Side Pagination</h4>
                <p class="configuration-section-desc">
                  Server-side pagination requests each page individually loaded upon navigation.
                </p>
                <p
                  v-if="dataSetup.server_side_pagination && sourceType === 'external_url'"
                  class="configuration-section-desc">
                  The query params limit & page will be sent automatically to the endpoint that was setup
                  in the API List Data config for handling server side pagination. <br> Sample :
                </p>
                <p
                  v-if="dataSetup.server_side_pagination && sourceType === 'external_url'"
                  class="configuration-section-desc-gray">https://gateway.sample.io/endpoint/get?<b>limit=x&page=x</b></p>
              </div>
              <j-switch
                v-model="dataSetup.server_side_pagination"
                :disabled="isDataset"
              />
            </div>
            <div
              v-if="!dataSetup.server_side_pagination"
              class="config-information"
            >
              <p>If you choose to set <b>Server Side Pagination</b> to <span class="text-red">false</span>, it will switch to <b>Client Side Pagination</b> mode and load only 10,000 records</p>
            </div>
          </div>
        </div>

        <!-- Search Options Section -->
        <div class="section-field input-field">
          <h4 class="title-section">Search Options</h4>

          <!-- Fields Search Options Configuration -->
          <div class="configuration-section">
            <h4 class="configuration-section-title">Fields</h4>
            <p class="configuration-section-desc">
              The field used can be adjusted as needed
            </p>

            <draggable
              v-model="dataSetup.search_options_list"
              :options="{
                animation:300,
                handle:'.icon-drag'
              }"
              class="d-flex flex-wrap"
            >
              <div
                v-for="(data, index) in dataSetup.search_options_list"
                :key="index"
                :class="{'selected': index === selectedIndexField && mode === 'search'}"
                class="field-list"
              >
                <p class="column-name">{{ data.name }}</p>

                <field-preview
                  :column="data"
                />

                <!-- Edit or Delete -->
                <div class="edit-or-delete">
                  <div class="button">
                    <!-- Edit -->
                    <div
                      class="edit"
                      @click="editField(index, 'search')"
                    >
                      <i class="fa fa-pencil-square-o" />
                    </div>
                    <!-- Delete -->
                    <div
                      class="delete"
                      @click="deleteField(index, 'search')"
                    >
                      <i class="fa fa-trash" />
                    </div>
                  </div>
                </div>
              </div>
            </draggable>

            <div
              class="btn-add-config"
              @click="openModalFieldLibrary('search')"
            >
              + Add Field
            </div>
          </div>

          <!-- Show Search Field Configuration -->
          <div class="configuration-section">
            <div class="configuration-toggle-in-title">
              <div class="wrap-title">
                <h4 class="configuration-section-title">Show Search Field</h4>
                <p class="configuration-section-desc">
                  Field will be show on table view without click button filter
                </p>
              </div>
              <j-switch v-model="dataSetup.auto_show_search_options_list" />
            </div>
          </div>
        </div>

        <!-- Tag Filter Section -->
        <div
          v-if="sourceType === 'form'"
          class="section-field input-field">
          <h4 class="title-section">Tag Filter</h4>

          <div class="configuration-section">
            <div class="configuration-toggle-in-title">
              <div class="wrap-title">
                <h4 class="configuration-section-title">Dynamic Tag Filter</h4>
                <p class="configuration-section-desc">Tag will be show on table view to represent grouping data</p>
              </div>
              <j-toggle
                v-model="dataSetup.config_tag_filter.is_use_tag_filter"
                class="toggle"/>
            </div>
            <div v-if="dataSetup.config_tag_filter.is_use_tag_filter">
              <b-form
                :class="{'error-input': $v.dataSetup.config_tag_filter.function_name.$error}"
                class="mb-2">
                <label> Function </label>
                <j-single-select
                  v-model="dataSetup.config_tag_filter.function_name"
                  :options="listFunction"
                  :placeholder="'Select Function'"
                  :error-required="false"
                  label="name" />
              </b-form>

              <b-form :class="{'error-input': $v.dataSetup.config_tag_filter.style.$error}">
                <div class="configuration-section-title"> Style </div>
                <p class="configuration-section-desc"> Select the type of style for tag filter </p>
                <div class="div-summary-list-type mt-2">
                  <div
                    :class="{'type--active': dataSetup.config_tag_filter.style === 'button'}"
                    class="type"
                    @click="dataSetup.config_tag_filter.style = 'button'"
                  >
                    Button Style
                  </div>
                  <div
                    :class="{'type--active': dataSetup.config_tag_filter.style === 'tab'}"
                    class="type"
                    @click="dataSetup.config_tag_filter.style = 'tab'"
                  >
                    Tab Style
                  </div>
                </div>
              </b-form>
            </div>
          </div>
        </div>

        <!-- Others Section -->
        <div
          class="section-field input-field"
        >
          <h4 class="title-section">Others</h4>

          <template v-if="sourceType !== 'dataset'">
            <!-- Bulk Actions Configuration -->
            <div
              v-if="type === 'default' || type === 'requestor'"
              class="configuration-section"
            >
              <h4 class="configuration-section-title">Bulk Actions</h4>
              <p class="configuration-section-desc">
                It's a faster action than a row by row operation, but this is best used when execute limited rows.
              </p>

              <b-form>
                <div>
                  <div
                    v-if="type === 'default'"
                    class="div-input-location"
                  >
                    <label for="">Action Update</label>
                    <j-switch v-model="dataSetup.is_use_bulking_update" />
                  </div>
                  <div v-if="dataSetup.is_use_bulking_update">
                    <div
                      v-for="(data, index) in dataSetup.column_bulking_update"
                      :key="index"
                      :class="{'selected': index === selectedIndexField && mode === 'bulk'}"
                      class="field-list"
                    >
                      <p class="column-name ml-0">{{ data.name || 'Field Name' }}</p>

                      <field-preview
                        :use-drag-icon="false"
                        :column="data"
                      />

                      <!-- Edit or Delete -->
                      <div class="edit-or-delete">
                        <div class="button">
                          <!-- Edit -->
                          <div
                            class="edit"
                            @click="editField(0, 'bulk')"
                          >
                            <i class="fa fa-pencil-square-o" />
                          </div>
                          <!-- Delete -->
                          <div
                            class="delete"
                            @click="deleteField(0, 'bulk')"
                          >
                            <i class="fa fa-trash" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="sourceType === 'form'"
                    class="div-input-location">
                    <label for="">Action Delete</label>
                    <j-switch v-model="dataSetup.is_use_bulking_delete" />
                  </div>
                </div>
              </b-form>
            </div>

            <!-- Hide Checkbox Configuration -->
            <div
              v-if="type === 'requestor' || type === 'approver'"
              class="configuration-section"
            >
              <div class="configuration-toggle-in-title">
                <div class="wrap-title">
                  <h4 class="configuration-section-title">Hide Checkbox</h4>
                  <p class="configuration-section-desc">Allows to disable bulk action {{ type === 'approver' ? 'approval' : type }}</p>
                </div>
                <j-switch v-model="dataSetup.isHideCheckbox" />
              </div>
            </div>

            <!-- Preview Data Configuration -->
            <div
              v-if="sourceType === 'form'"
              class="configuration-section">
              <h4 class="configuration-section-title">Preview Data</h4>
              <p class="configuration-section-desc">
                Configuration to show preview data before execute bulk actions
              </p>

              <b-form>
                <div class="div-input-location">
                  <label>Summary of Selected Data</label>
                  <j-switch v-model="dataSetup.config_preview_data.is_show_summary_data" />
                </div>
                <div v-if="dataSetup.config_preview_data.is_show_summary_data">
                  <b-form
                    :class="{'error-input': $v.dataSetup.config_preview_data.summary_label.$error}"
                    class="m__b--14">
                    <label> Summary Label </label>
                    <j-input
                      v-model="dataSetup.config_preview_data.summary_label"
                      :error-required="false"
                      placeholder="Enter summary label"
                    />
                  </b-form>
                  <div class="field-list">
                    <b-form
                      :class="{'error-input': $v.dataSetup.config_preview_data.summary_data.$error}"
                    >
                      <label>column</label>
                      <j-single-select
                        v-model="dataSetup.config_preview_data.summary_data"
                        :error-required="false"
                        :options="summaryDataOptions"
                        label="label"
                        placeholder="Select Column of Data"
                      />
                    </b-form>
                  </div>
                </div>

                <div class="div-input-location">
                  <label>List of Selected Data</label>
                  <j-switch v-model="dataSetup.config_preview_data.is_show_summary_list" />
                </div>
                <div
                  v-if="dataSetup.config_preview_data.is_show_summary_list"
                  class="div-summary-list">
                  <p>Define column of table to show selected data list. By default table view config or custom column.</p>
                  <div class="div-summary-list-type">
                    <div
                      :class="{ 'type--active' : dataSetup.config_preview_data.summary_list_type === 'by_default' }"
                      class="type"
                      @click="setSummaryListType('by_default')" >
                      By Default
                    </div>
                    <div
                      :class="{ 'type--active' : dataSetup.config_preview_data.summary_list_type === 'custom' }"
                      class="type"
                      @click="setSummaryListType('custom')" >
                      Custom
                    </div>
                  </div>
                </div>
                <div
                  v-if="dataSetup.config_preview_data.is_show_summary_list && dataSetup.config_preview_data.summary_list_type === 'custom'"
                  class="div-summary-list">

                  <!-- Summary List -->
                  <draggable
                    v-if="dataSetup.config_preview_data.summary_list"
                    v-model="dataSetup.config_preview_data.summary_list"
                    :options="{
                      animation:300,
                      handle:'.icon-drag'
                  }">
                    <div
                      v-for="(data, index) in dataSetup.config_preview_data.summary_list"
                      :key="index"
                      class="field-list">

                      <div class="d-flex align-items-center">
                        <img
                          src="@/assets/new-form-ui/dragged.svg"
                          class="icon-drag"
                        >
                        <b-row class="w-100 py-1">
                          <b-col md="6">
                            <span class="summary-list-column">{{ data.name }}</span>
                          </b-col>
                          <b-col md="6">
                            <span class="summary-list-column">{{ data.key }}</span>
                          </b-col>
                        </b-row>
                      </div>

                      <!-- Edit or Delete -->
                      <div class="edit-or-delete">
                        <div class="button">
                          <!-- Edit -->
                          <div
                            class="edit"
                            @click="openConfigColumn(data, index)"
                          >
                            <i class="fa fa-pencil-square-o"/>
                          </div>
                          <!-- Delete -->
                          <div
                            class="delete"
                            @click="deleteColumnSummary(index)">
                            <i class="fa fa-trash"/>
                          </div>
                        </div>
                      </div>
                    </div>
                  </draggable>

                  <!-- If not have summary list yet -->
                  <div
                    v-show="dataSetup.config_preview_data.summary_list.length === 0"
                    :class="{'error-input': $v.dataSetup.config_preview_data.summary_list.$error}"
                    class="field-list">

                    <div class="d-flex align-items-center">
                      <img
                        src="@/assets/new-form-ui/dragged.svg"
                        class="icon-drag"
                      >
                      <b-row class="w-100">
                        <b-col md="6">
                          <span>Column_name</span>
                        </b-col>
                        <b-col md="6">
                          <span>Column_key</span>
                        </b-col>
                      </b-row>
                    </div>

                    <div class="edit-or-delete">
                      <div class="button">
                        <!-- Edit -->
                        <div
                          class="edit"
                          @click="openConfigColumn(null, null)"
                        >
                          <i class="fa fa-pencil-square-o"/>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="btn-add-config"
                    @click="openConfigColumn(null, null)">
                    <span class="plus-icon">+</span>
                    Add Column
                  </div>
                </div>
              </b-form>
            </div>

            <!-- Row Expansion -->
            <div class="configuration-section">
              <div class="configuration-toggle-in-title">
                <div class="wrap-title">
                  <h4 class="configuration-section-title">Row Expansion</h4>
                  <p class="configuration-section-desc">Expanding row makes it easier for users to read data</p>
                </div>
                <j-toggle
                  v-model="dataSetup.row_expansion"
                  class="toggle"/>
              </div>
            </div>
          </template>

          <!-- Default Rows Page -->
          <div class="configuration-section">
            <h4 class="configuration-section-title">Rows Per Page</h4>
            <p class="configuration-section-desc">Option list for total rows per page  as a default, and the maximum limit that can be applied per page is 10,000 records.</p>
            <div
              v-if="isErrorRowPerPage"
              class="error-required-container">
              <div class="title-error">ERROR</div>
              Please select one option to set as the default for the total number of rows displayed on initial load
            </div>
            <div
              v-for="(option, index) in dataSetup.rows_page_option"
              :key="index"
            >
              <div
                :class="{'error-input': dataSetup.rows_page_option.length > 0 && $v.dataSetup.rows_page_option.$each[index].$error}"
                class="div-row-page-option"
              >
                <input
                  :id="option"
                  v-model="dataSetup.rows_page_default"
                  :value="option"
                  :disabled="option === ''"
                  type="radio"
                >
                <input
                  v-model="dataSetup.rows_page_option[index]"
                  type="number"
                  placeholder="Option"
                >
                <i
                  class="fa fa-trash cursor-pointer"
                  @click="deleteRowPageOption(index)"/>
              </div>
            </div>
            <div
              class="btn-add-config"
              @click="addRowPageOption">
              + Add Option
            </div>
          </div>

          <!-- Freeze Header Table -->
          <div class="configuration-section">
            <div class="configuration-toggle-in-title">
              <div class="wrap-title">
                <h4 class="configuration-section-title">Freeze Header Table</h4>
                <p class="configuration-section-desc">Prevents the row headers of a table from scrolling out of view while examining extensive data</p>
              </div>
              <j-toggle
                v-model="dataSetup.freeze_header_table"
                class="toggle"/>
            </div>
          </div>

          <!-- Disable Redirect To Detail Page -->
          <div class="configuration-section">
            <div class="configuration-toggle-in-title">
              <div class="wrap-title">
                <h4 class="configuration-section-title">Disable Redirect To Detail Page</h4>
                <p class="configuration-section-desc">When you click on a table row, you will remain on the same page and will not be redirected to a detail page</p>
              </div>
              <j-toggle
                v-model="dataSetup.disable_redirect_detail_page"
                class="toggle"/>
            </div>
          </div>
        </div>
      </div>

      <!-- Configuration Button -->
      <div
        :class="{ 'justify-content-end': !isHaveConfiguration }"
        class="properties-field-button"
      >
        <button
          v-if="isHaveConfiguration && type !== 'default'"
          :disabled="showModalFieldLibrary"
          class="button-border"
          @click="deleteView"
        >
          <i class="fa fa-trash" /> Delete
        </button>

        <div class="d-flex align-items-center">
          <button
            :disabled="showModalFieldLibrary"
            class="button-border mr-2"
            @click="submitForm(true)"
          >
            Close
          </button>

          <button
            :disabled="showModalFieldLibrary"
            class="button-blue"
            @click="submitForm(false)"
          >
            Apply
          </button>
        </div>
      </div>
    </div>

    <!-- Properties -->
    <properties-field
      v-if="selectedField"
      :ref="idProperties"
      :id="[idProperties]"
      :field-detail="selectedField"
      :variable-options="variables"
      :field-ui-key="dataSetup.search_options_list"
      :is-group="true"
      :is-new-field="isNewFieldGroup"
      @delete-field="deleteField(selectedIndexField, mode)"
      @close-properties="togglePropertiesField(false)"
      @submit-mode="submitField"
    />

    <!-- Column Configuration -->
    <column-configuration
      v-if="isOpenConfigColumn"
      :ref="idConfigColumnSummary"
      :id="idConfigColumnSummary"
      :field-detail="selectedColumn"
      :select-variable="variableOptionsColumn"
      :is-group="true"
      type="summary"
      @close-configuration="toggleConfigurationColumn(false)"
      @submit-configuration="submitColumnSummary"
      @delete-configuration="deleteColumnSummary"
    />
  </div>
</template>

<script>
/* eslint-disable max-len */
import { mapState, mapMutations, mapActions } from 'vuex';
import { required, requiredIf, maxValue } from 'vuelidate/lib/validators';
import draggable from 'vuedraggable';
// Components
import PropertiesField from '@/views/experience-manager-v2/partials/PropertiesField';
import FieldPreview from '@/views/experience-manager-v2/partials/FieldPreview';
import ColumnConfiguration from '@/views/experience-manager-v2/partials/configuration/ColumnConfiguration';
import jSwitch from '@/components/inputs/jSwitch';
import jMixAutoScroll from '@/mixins/jMixAutoScroll';

export default {
  name: 'TableConfiguration',

  components: {
    draggable,
    PropertiesField,
    FieldPreview,
    ColumnConfiguration,
    jSwitch,
  },

  mixins: [jMixAutoScroll],

  props: {
    id: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'default',
    },
    dataConfig: {
      type: Object,
      default: () => {},
    },
    listFunction: {
      type: Array,
      default: () => [],
    },
    variables: {
      type: Array,
      default: () => [],
    },
    variableOptions: {
      type: Array,
      default: () => [],
    },
    variableOptionsColumn: {
      type: Array,
      default: () => [],
    },
    isHaveConfiguration: {
      type: Boolean,
      default: false,
    },
    sourceType: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      idModalFieldLibrary: 'modalFieldLibrary',
      dataSetup: {
        title: null,
        server_side_pagination: false,
        sorting: {
          key: null,
          order: null,
        },
        filter: [
          {
            key: null,
            value: null,
          },
        ],
        filter_function: [
          {
            key: null,
            value: null,
            skip_null_value: false,
          },
        ],
        filterOperator: 'and',
        is_use_bulking_update: false,
        is_use_bulking_delete: false,
        column_bulking_update: [],
        auto_show_search_options_list: false,
        search_options_list: [],
        config_preview_data: {
          is_show_summary_data: false,
          summary_data: null,
          summary_label: '',
          is_show_summary_list: false,
          summary_list_type: null,
          summary_list: [],
        },
        row_expansion: false,
        rows_page_default: 10,
        rows_page_option: [10, 20, 50, 100],
        freeze_header_table: false,
        config_tag_filter: {
          is_use_tag_filter: false,
          function_name: null,
          style: '',
        },
        disable_redirect_detail_page: false,
      },
      orderOptions: [
        {
          id: 'asc',
          label: 'Ascending',
          text: 'Ascending',
        },
        {
          id: 'desc',
          label: 'Descending',
          text: 'Descending',
        },
      ],
      filterOperatorOptions: [
        {
          id: 'and',
          name: 'AND',
        },
        {
          id: 'or',
          name: 'OR',
        },
      ],
      mode: '',
      isNewFieldGroup: false,
      idProperties: 'configProperties',
      showFilterOptions: false,
      selectedField: null,
      selectedIndexField: null,
      summaryDataOptions: null,
      isErrorRowPerPage: false,

      // for stack column configuration (summary list)
      idConfigColumnSummary: 'configurationColumnSummary',
      selectedColumn: null,
      selectedIndexColumn: null,
      isOpenConfigColumn: false,
    };
  },

  computed: {
    ...mapState('jStoreExperienceManagerV2', [
      'showModalFieldLibrary', 'sourceModalFieldLibrary', 'isShowModalFieldFromGroup', 'propertiesGroup', 'isDataset',
    ]),
  },

  watch: {
    // Watch state if select field in modal field library
    showModalFieldLibrary(val) {
      const data = this.sourceModalFieldLibrary;
      if (!val) {
        if (data) {
          if (this.mode === 'search') {
            const index = this.dataSetup.search_options_list.push(data) - 1;
            this.selectedField = this.dataSetup.search_options_list[index];
            this.selectedIndexField = index;
          } else if (this.mode === 'bulk') {
            const index = this.dataSetup.column_bulking_update.push(data) - 1;
            this.selectedField = this.dataSetup.column_bulking_update[index];
            this.selectedIndexField = index;
          }
          this.isNewFieldGroup = true;
          this.setSourceModalFieldLibrary(null);

          setTimeout(() => {
            this.togglePropertiesField(true);
          }, 100);
        } else {
          this.setIsSearch(false);
          this.setIsBulk(false);
        }
      }
    },

    // eslint-disable-next-line
    'dataSetup.is_use_bulking_update': function (data) {
      if (data && !this.dataSetup.column_bulking_update.length) {
        this.openModalFieldLibrary('bulk');
      }
    },

    isShowModalFieldFromGroup(val) {
      if (!val && !this.column_bulking_update && !this.selectedField && this.mode === 'bulk') {
        this.dataSetup.is_use_bulking_update = false;
      }
    },

    // eslint-disable-next-line
    'dataSetup.config_preview_data.is_show_summary_data': function (data) {
      if (data) {
        this.summaryDataOptions = this.variables.filter(val => val.type === 'number');

        if (this.dataSetup.config_preview_data.summary_data === '') {
          this.dataSetup.config_preview_data.summary_data = null;
        }
      }
    },

    // eslint-disable-next-line
    'dataSetup.config_preview_data.is_show_summary_list': function (data) {
      if (data && !this.dataSetup.config_preview_data.summary_list_type) this.setSummaryListType('by_default');
    },
  },

  created() {
    if (this.dataConfig) {
      this.dataSetup.title = this.dataConfig.title || null;
      this.dataSetup.sorting = this.dataConfig.sorting;
      this.dataSetup.filter = this.dataConfig.filter;
      this.dataSetup.filter_function = this.dataConfig.filter_function;
      this.dataSetup.filterOperator = this.dataConfig.filterOperator || 'and';
      this.dataSetup.server_side_pagination = this.isDataset ? true : this.dataConfig.server_side_pagination || false;
      this.dataSetup.auto_show_search_options_list = this.dataConfig.auto_show_search_options_list || false;
      this.dataSetup.search_options_list = this.dataConfig.search_options_list || [];
      this.dataSetup.config_preview_data = this._.cloneDeep(this.dataConfig.config_preview_data);
      this.dataSetup.row_expansion = this.dataConfig.row_expansion;
      this.dataSetup.rows_page_default = this.dataConfig.rows_page_default;
      this.dataSetup.rows_page_option = this.dataConfig.rows_page_option;
      this.dataSetup.freeze_header_table = this.dataConfig.freeze_header_table;
      this.dataSetup.config_tag_filter = this.dataConfig.config_tag_filter ? {
        is_use_tag_filter: this.dataConfig.config_tag_filter.is_use_tag_filter || false,
        function_name: this.dataConfig.config_tag_filter.function_name || null,
        style: this.dataConfig.config_tag_filter.style || '',
      } : {
        is_use_tag_filter: false,
        function_name: null,
        style: '',
      };
      this.dataSetup.disable_redirect_detail_page = this.dataConfig.disable_redirect_detail_page;

      if (this.type === 'default') {
        this.dataSetup.is_use_bulking_update = this.dataConfig.is_use_bulking_update || false;
        this.dataSetup.is_use_bulking_delete = this.dataConfig.is_use_bulking_delete || false;
        this.dataSetup.column_bulking_update = this.dataConfig.column_bulking_update ? [this.dataConfig.column_bulking_update] : [];
      } else if (this.type === 'requestor') {
        this.dataSetup.is_use_bulking_delete = this.dataConfig.is_use_bulking_delete || false;
        delete this.dataSetup.is_use_bulking_update;
        delete this.dataSetup.column_bulking_update;
        this.dataSetup.isHideCheckbox = this.dataConfig.isHideCheckbox;
      } else if (this.type === 'approver') {
        delete this.dataSetup.is_use_bulking_update;
        delete this.dataSetup.is_use_bulking_delete;
        delete this.dataSetup.column_bulking_update;
        this.dataSetup.isHideCheckbox = this.dataConfig.isHideCheckbox;
      }
    } else {
      this.dataSetup.server_side_pagination = !!this.isDataset;
    }
  },

  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleProblem']),
    ...mapMutations('jStoreExperienceManagerV2', [
      'setIsBulk', 'setIsSearch', 'setIsShowModalFieldFromGroup',
      'setShowModalFieldLibrary', 'setSourceModalFieldLibrary',
    ]),

    submitForm(isCancel) {
      if (!isCancel) {
        this.$v.dataSetup.$touch();
        this.isErrorRowPerPage = !this.dataSetup.rows_page_option.includes(this.dataSetup.rows_page_default);
        if (!this.$v.dataSetup.$error && !this.isErrorRowPerPage) {
          this.isErrorRowPerPage = false;
          this.$emit('submit', this.dataSetup, isCancel, this.type, this.sourceType);
          this.closeConfiguration();
        } else {
          this.scrollToErrorField('error-input');
        }
      } else {
        this.closeConfiguration();
      }
    },

    deleteView() {
      this.$emit('delete-view', this.type);
    },

    closeConfiguration() {
      this.$emit('close-configuration');

      setTimeout(() => {
        this.dataSetup = {
          title: null,
          server_side_pagination: false,
          sorting: {
            key: null,
            order: null,
          },
          filter: [
            {
              key: null,
              value: null,
            },
          ],
          filter_function: [
            {
              key: null,
              value: null,
              skip_null_value: false,
            },
          ],
          filterOperator: 'and',
          is_use_bulking_update: false,
          is_use_bulking_delete: false,
          column_bulking_update: [],
          auto_show_search_options_list: false,
          search_options_list: [],
          config_preview_data: {
            is_show_summary_data: false,
            summary_data: null,
            summary_label: '',
            is_show_summary_list: false,
            summary_list_type: null,
            summary_list: [],
          },
          row_expansion: false,
          rows_page_default: 10,
          rows_page_option: [10, 20, 50, 100],
          freeze_header_table: false,
          config_tag_filter: {
            is_use_tag_filter: false,
            function_name: null,
            style: '',
          },
          disable_redirect_detail_page: false,
        };

        this.$v.dataSetup.$reset();
      }, 400);
    },

    addFilter() {
      this.dataSetup.filter.push({
        key: null,
        value: null,
      });
    },

    deleteFilter(index) {
      this.dataSetup.filter.splice(index, 1);
    },

    addFilterFunction() {
      this.dataSetup.filter_function.push({
        key: null,
        value: null,
        skip_null_value: false,
      });
    },

    deleteFilterFunction(index) {
      this.dataSetup.filter_function.splice(index, 1);
    },

    closeFilterOptions(id) {
      this.dataSetup.filterOperator = id;
      this.showFilterOptions = false;
    },

    // Open modal field library (search options list and bulk update)
    openModalFieldLibrary(mode) {
      this.mode = mode;

      if (!this.selectedField) {
        if (this.mode === 'search') {
          this.setIsSearch(true);
        } else if (this.mode === 'bulk') {
          this.setIsBulk(true);
        }
        this.setIsShowModalFieldFromGroup(true);
        this.setShowModalFieldLibrary(true);

        setTimeout(() => {
          const element = document.getElementById(this.idModalFieldLibrary);
          if (element) element.classList.add('show');
        }, 100);
      }
    },

    // Edit field on search options list or bulk update
    editField(index, mode) {
      this.mode = mode;

      if (this.mode === 'search') {
        this.selectedField = this.dataSetup.search_options_list[index];
        this.setIsSearch(true);
      } else if (this.mode === 'bulk') {
        this.selectedField = this.dataSetup.column_bulking_update[index];
        this.setIsBulk(true);
      }
      this.selectedIndexField = index;
      this.togglePropertiesField(true);
    },

    // Delete field search option or bulk update
    deleteField(index, mode) {
      this.mode = mode;
      this.popupDeleteField(index);
    },

    popupDeleteField(index) {
      this.$swal({
        title: 'Delete',
        text: 'Are you sure to delete field ?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D0021B',
        cancelButtonColor: '#606060',
        titleColor: '#676767',
      }).then(async (result) => {
        if (result.value) {
          if (this.mode === 'search') {
            this.dataSetup.search_options_list.splice(index || this.selectedIndexField, 1);
          } else if (this.mode === 'bulk') {
            this.dataSetup.column_bulking_update.splice(index || this.selectedIndexField, 1);
            this.dataSetup.is_use_bulking_update = false;
            if (this.propertiesGroup) this.togglePropertiesField(false);
          }
          this.mode = '';
        }
      });
    },

    // Open/close stacked properties
    togglePropertiesField(status) {
      if (status) {
        setTimeout(() => {
          const element = document.getElementById(this.idProperties);
          const elementParent = document.getElementById(this.id);
          if (element) {
            elementParent.classList.add('show-properties-group');
            element.classList.add('show-properties-field');
          }
        }, 200);
      } else {
        const element = document.getElementById(this.idProperties);
        const elementParent = document.getElementById(this.id);
        if (element) {
          element.classList.remove('show-properties-field');
          elementParent.classList.remove('show-properties-group');
        }

        setTimeout(() => {
          this.selectedField = null;
          this.selectedIndexField = null;
          this.isNewFieldGroup = false;
          this.mode = '';
          this.setIsBulk(false);
          this.setIsSearch(false);
        }, 200);
      }
    },

    // Submit data in stacked properties
    submitField(mode, params, isCancel) {
      if (this.mode === 'bulk') {
        if (params.field_ui_key) {
          const sourceData = this.dataSetup.column_bulking_update;
          const findKeySame = sourceData.find(e => e.field_ui_key === params.field_ui_key);

          if (mode === 'add') {
            if (!findKeySame) {
              this.isError = false;
              if (!isCancel) {
                this.dataSetup.column_bulking_update.push(params);
                this.togglePropertiesField(false);
              }
            } else {
              this.isError = true;
              this.toggleProblem('Variable cannot be the same!');
              setTimeout(() => {
                this.isError = false;
              }, 500);
            }
          } else {
            // eslint-disable-next-line
            if (this.selectedField.field_ui_key === params.field_ui_key) {
              this.isError = false;
              if (!isCancel) {
                this.dataSetup.column_bulking_update[this.selectedIndexField] = params;
                this.togglePropertiesField(false);
              }
            } else {
              // eslint-disable-next-line
              if (!findKeySame) {
                this.isError = false;
                if (!isCancel) {
                  this.dataSetup.column_bulking_update[this.selectedIndexField] = params;
                  this.togglePropertiesField(false);
                }
              } else {
                this.isError = true;
                this.toggleProblem('Variable cannot be the same!');
                setTimeout(() => {
                  this.isError = false;
                }, 500);
              }
            }
          }
        } else {
          this.dataSetup.column_bulking_update.splice(this.selectedIndexField, 1);
          this.dataSetup.is_use_bulking_update = false;
        }
      } else if (this.mode === 'search') {
        if (params.field_data_key) {
          const param = {
            type: params.type,
            name: params.name,
            config: params.config,
            field_data_key: params.field_data_key,
          };

          if (mode === 'add') {
            if (!isCancel) {
              this.dataSetup.search_options_list.push(param);
              this.togglePropertiesField(false);
            }
          } else if (mode === 'edit') {
            if (!isCancel) {
              this.dataSetup.search_options_list[this.selectedIndexField] = param;
              this.togglePropertiesField(false);
            }
          }
        } else {
          this.dataSetup.search_options_list.splice(this.selectedIndexField, 1);
        }
      }

      this.setIsSearch(false);
      this.setIsBulk(false);
    },

    setSummaryListType(type) {
      if (type) {
        this.dataSetup.config_preview_data.summary_list_type = type;
      }
    },

    // Open/edit config configuration for summary list
    openConfigColumn(column, index) {
      if (this.selectedColumn) {
        this.toggleConfigurationColumn(false);

        setTimeout(() => {
          this.selectedColumn = column;
          this.selectedIndexColumn = index;
          this.toggleConfigurationColumn(true);
        }, 250);
      } else {
        this.selectedColumn = column;
        this.selectedIndexColumn = index;
        this.toggleConfigurationColumn(true);
      }
    },

    toggleConfigurationColumn(status) {
      if (status) {
        this.isOpenConfigColumn = true;

        setTimeout(() => {
          const elementParent = document.getElementById('tableConfiguration');
          const element = document.getElementById(this.idConfigColumnSummary);
          if (element) {
            elementParent.classList.add('show-properties-group');
            element.classList.add('show-properties-field');
          }
        }, 200);
      } else {
        const elementParent = document.getElementById('tableConfiguration');
        const element = document.getElementById(this.idConfigColumnSummary);

        if (element) {
          element.classList.remove('show-properties-field');
          elementParent.classList.remove('show-properties-group');
        }

        setTimeout(() => {
          this.selectedColumn = null;
          this.selectedIndexColumn = null;
          this.isOpenConfigColumn = false;
        }, 200);
      }
    },

    // Submit summary list preview data
    submitColumnSummary(mode, params) {
      const data = Object.assign({}, params);
      delete data.action_buttons;
      if (mode === 'add') {
        this.dataSetup.config_preview_data.summary_list.push(data);
      } else {
        this.dataSetup.config_preview_data.summary_list[this.selectedIndexColumn] = data;
      }
      this.toggleConfigurationColumn(false);
    },

    // Delete summary list preview data
    deleteColumnSummary(index) {
      this.$swal({
        title: 'Delete',
        text: 'Are you sure want to delete this column?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D0021B',
        cancelButtonColor: '#606060',
        titleColor: '#676767',
      }).then(async (result) => {
        if (result.value) {
          this.dataSetup.config_preview_data.summary_list.splice(index || this.selectedIndexColumn, 1);

          if (this.isOpenConfigColumn) this.toggleConfigurationColumn(false);
        }
      });
    },

    addRowPageOption() {
      if (Array.isArray(this.dataSetup.rows_page_option)) {
        this.dataSetup.rows_page_option.push('');
      } else {
        this.dataSetup.rows_page_option = [];
        this.dataSetup.rows_page_option.push('');
      }
    },

    deleteRowPageOption(index) {
      this.dataSetup.rows_page_option.splice(index, 1);
    },
  },

  validations() {
    return {
      dataSetup: {
        title: { required },
        sorting: {
          key: {
            required: requiredIf(() => !this.isDataset),
          },
          order: {
            required: requiredIf(() => !this.isDataset),
          },
        },
        filter: {},
        filter_function: {},
        filterOperator: {},
        config_preview_data: {
          summary_data: {
            required: requiredIf(() => this.dataSetup.config_preview_data.is_show_summary_data),
          },
          summary_label: {
            required: requiredIf(() => this.dataSetup.config_preview_data.is_show_summary_data),
          },
          summary_list: {
            required: requiredIf(() => this.dataSetup.config_preview_data.summary_list_type === 'custom' && this.dataSetup.config_preview_data.summary_list.length === 0),
          },
        },
        rows_page_option: {
          $each: {
            maxValue: maxValue(10000),
          },
        },
        config_tag_filter: {
          function_name: {
            required: requiredIf(() => this.dataSetup.config_tag_filter.is_use_tag_filter),
          },
          style: {
            required: requiredIf(() => this.dataSetup.config_tag_filter.is_use_tag_filter),
          },
        },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/partials/configuration/TableConfiguration.vue